
export const SHOW_WEEKEND_FLAG = 'SHOW_CALENDAR_WEEKEND';

export const CALENDAR_VIEWS = {
    TASK: 'TASK',
    PO: 'PO',
    PROJECT: 'PROJECT',
};
